import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class PCIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 173.8">
                <rect x={44.06} y={16.78} width={211.88} height={115.88} rx={6.76} ry={6.76} fill={secondaryColor} />
                <path
                    d="M265 0H35a6.76 6.76 0 0 0-6.76 6.76v140.76h243.57V6.76A6.76 6.76 0 0 0 265 0zm-9.06 125.9a6.76 6.76 0 0 1-6.76 6.76H50.82a6.76 6.76 0 0 1-6.76-6.76V23.54a6.76 6.76 0 0 1 6.76-6.76h198.36a6.76 6.76 0 0 1 6.76 6.76zM169.7 152.95v1.46a3 3 0 0 1-3 3h-33.35a3 3 0 0 1-3-3v-1.46H0v3.68a17.16 17.16 0 0 0 17.16 17.17h265.68A17.16 17.16 0 0 0 300 156.64v-3.68z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(PCIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/PCIcon.js